export default __webpack_public_path__ + "static/image-001-33f3e88231a1d7af9c3a39106ac25454.png";